import { Quote } from "lucide-react";
import { Reveal, OWNER, TANYA_PHOTO } from "./shared";

export default function OwnerNote() {
  return (
    <section data-testid="owner-note" className="bg-white py-24 md:py-32 overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="relative bg-blush/50 rounded-[2.5rem] overflow-hidden grid md:grid-cols-2 items-stretch">
            <div className="pointer-events-none absolute -top-10 -right-10 w-40 h-40 rounded-full bg-pink/25 blur-2xl animate-floaty" />

            {/* Photo */}
            <div className="relative min-h-[380px] md:min-h-[560px]">
              <img
                src={TANYA_PHOTO}
                alt="Tanya Bursova, owner of Tanya's Cleaning"
                data-testid="owner-photo"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-teal/25 to-transparent md:bg-gradient-to-r md:from-transparent md:to-blush/40" />
            </div>

            {/* Text */}
            <div className="relative px-8 py-12 md:px-14 md:py-16 flex flex-col justify-center">
              <span className="inline-flex w-14 h-14 rounded-full bg-white items-center justify-center shadow-md ring-1 ring-blush mb-6">
                <Quote size={24} className="text-pink-dark" strokeWidth={1.5} />
              </span>

              <p className="text-sm uppercase tracking-[0.25em] text-pink-dark font-semibold mb-5">
                A Note From Our Founder
              </p>

              <p className="font-serif-display text-2xl sm:text-3xl text-teal leading-snug">
                “Hi, I&apos;m Tanya — the owner of this company, and a mom. I know first-hand
                how much a clean, calm home matters, and how hard it can be to find the time for it.
                That&apos;s exactly why we&apos;re here: to take the whole load off your shoulders,
                so you can simply relax and enjoy your space.”
              </p>

              <div className="mt-8">
                <p className="font-serif-display text-xl text-teal leading-none">{OWNER}</p>
                <p className="text-sm text-teal-soft mt-1">Owner &amp; Founder · Edmonton, AB</p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
